export default __webpack_public_path__ + "static/productImage-d96433b79345dee711c712a35933a718.jpg";